import { useLocation } from 'react-router-dom';

import { routes } from 'core/routing';

const useIsCallbackRoute = () => {
  const { pathname } = useLocation();

  return pathname === routes.authCallback();
};

export default useIsCallbackRoute;
